import { __exports as e } from "./createSvgIcon2.mjs";
import n from "./index242.mjs";
var t;
function a() {
  return t ? e : (t = 1, function(r) {
    "use client";
    Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "default", {
      enumerable: !0,
      get: function() {
        return u.createSvgIcon;
      }
    });
    var u = n;
  }(e), e);
}
export {
  a as __require
};
//# sourceMappingURL=createSvgIcon.mjs.map
